import { Link } from 'react-router-dom';

export default function UeberUnsV2() {
  return (
    <div className="min-h-screen text-[var(--text)]">
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <div className="bg-white/85 backdrop-blur-sm rounded-2xl p-6 shadow-sm">
        <h1 className="text-2xl sm:text-3xl font-semibold mb-6">Über CarmaCircle</h1>
        
        <section className="space-y-6 text-sm sm:text-base text-[var(--text)] leading-relaxed">
          <div className="border-l-4 border-[var(--primary)] pl-4 py-2 bg-white/70 rounded-r-lg">
            <p className="italic text-[var(--muted)]">
              Ein ruhiger Ort, um Wertschätzung bewusst zu geben und zu empfangen – ohne Likes, Rankings oder Ablenkung.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-[var(--text)]">Unsere Philosophie</h2>
            
            <p>
              CarmaCircle ist ein Ort für echte Wertschätzung und positive Energie. Die Verherrlichung von Gewalt, Krieg, 
              Sexismus, Rassismus und anderen Dingen, die Lebewesen Schaden zufügen, findet hier keinen Platz.
            </p>

            <p>
              Besinne Dich bei der Verteilung von Carma zunächst gerne auf Deinen ganz persönlichen Weg und wie dieser 
              von Menschen in Deinem Umfeld positiv beeinflusst wurde oder wird. Denk über den Tellerrand hinaus und 
              erinnere Dich, wer oder was Dich in Deinem Leben bewegt hat. Vielleicht war es nur ein kleiner Moment, 
              eine Geste, ein einzelner Satz von jemandem – hat aber in Dir etwas positiv verändert.
            </p>

            <p>
              Oder Du denkst Dir: „Jemand hat genau das jetzt gebraucht!" und verschickst ein Carma an jemanden, 
              einfach dafür, dass die Person da ist. Es muss nicht immer etwas erfolgt sein, um sich erkenntlich zu zeigen. 
              Man darf auch einfach nur sein, so wie man ist. Das ist echte Wertschätzung!
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-[var(--text)]">Was ist Carma?</h2>
            <p>
              Carma ist eine persönliche Nachricht der Wertschätzung – ein digitaler Moment der Anerkennung, 
              den Du jemandem schenkst. Keine öffentlichen Likes, keine Follower-Zahlen, keine Algorithmen. 
              Nur Du und die Person, der Du etwas Gutes sagen möchtest.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-[var(--text)]">Stetige Weiterentwicklung</h2>
            <p>
              CarmaCircle wächst Schritt für Schritt weiter – mit dem Feedback unserer Nutzer:innen. 
              Danke, dass Du dabei bist!
            </p>
          </div>
        </section>

        <div className="mt-8 pt-6 border-t border-[var(--border)]">
          <div className="flex flex-wrap gap-3">
            <Link
              to="/give"
              className="inline-flex items-center justify-center rounded-full px-5 py-2 text-sm font-medium bg-[var(--primary)] text-[var(--primary-contrast)] hover:opacity-90"
            >
              Carma geben
            </Link>
            <Link
              to="/beta-guide"
              className="inline-flex items-center justify-center rounded-full px-5 py-2 text-sm font-medium border border-[var(--border)] bg-white/70 hover:bg-white/90"
            >
              Guide & Feedback
            </Link>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
